import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, services, states } from '@/utils'

import button from '@/components/button'
import buttonRefresh from '@/components/button/refresh'
import pagination from '@/components/pagination'
import preloader from '@/components/preloader'
import channels from '@/components/services/otp-settings/widgets/cols/third/channels'
import sourceBox from '@/components/source/box'
import sticker from '@/components/sticker'
import date from '@/components/templates/service/item/date'

const requestStatuses = {
  wait: {
    icon: icons.access_time,
    color: Colors.primary
  },
  channelChanged: {
    icon: icons.error_outline,
    color: Colors.error
  },
  resendChannel: {
    icon: icons.refresh,
    color: Colors.primary
  },
  noAvailableChannels: {
    icon: icons.error_outline,
    color: Colors.error
  },
  attemptsExpired: {
    icon: icons.error_outline,
    color: Colors.error
  },
  confirmed: {
    icon: icons.check_circle_outline,
    color: Colors.success
  },
  closed: {
    icon: icons.close,
    color: Colors.warning
  }
}

function renderHeader(h) {
  return h(
    components['tabs-header'],
    {
      props: {
        value: this.tab,
        tabs: this.tabs
      },
      on: {
        input: event => {
          this.tab = event
        }
      }
    }
  )
}

function renderDialogHeader(h) {
  return h(
    components['tabs-header'],
    {
      class: 'pa-2',
      props: {
        value: this.dialogTab,
        tabs: this.dialogTabs
      },
      slot: 'header',
      on: {
        input: event => {
          this.dialogTab = event
        }
      }
    }
  )
}
function renderDialogTabContentByKey(h, key) {
  switch (key) {
    case 'channels': {
      return h(
        channels,
        {
          props: {
            requestId: this.item.id
          }
        }
      )
    }
    case 'request': {
      return h(
        'div',
        {
          class: 'px-2'
        },
        [
          h(
            sourceBox,
            {
              props: {
                value: this.item,
                rounded: true
              }
            }
          )
        ]
      )
    }
  }
}
function renderDialogTab(h, key) {
  return h(
    'div',
    {
      key
    },
    [ renderDialogTabContentByKey.call(this, h, key) ]
  )
}
function renderDialogBody(h) {
  return h(
    components.tabs,
    {
      props: { value: this.dialogTab },
      scopedSlots: {
        body: () => {
          return this.dialogTabs.map(tab => {
            return renderDialogTab.call(this, h, tab.key)
          })
        }
      }
    }
  )
}
function renderDialogFooter(h) {
  return h(
    'div',
    {
      class: 'dialog__footer',
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              this.showDialog = false
            }
          }
        }
      )
    ]
  )
}
function renderDialog(h) {
  let maxWidth
  if (this.viewport.breakpoint.mdUp) {
    maxWidth = 800
  }

  return h(
    components.dialog,
    {
      props: {
        value: this.showDialog,
        maxWidth
      },
      on: {
        input: event => {
          this.showDialog = event
          if (event === false) {
            this.item = undefined
          }
        }
      }
    },
    [
      renderDialogHeader.call(this, h),
      renderDialogBody.call(this, h),
      renderDialogFooter.call(this, h)
    ]
  )
}

function renderPreloader(h) {
  return h(
    'div',
    {
      class: 'preloader__holder preloader__holder--absolute pa-5'
    },
    [ h(preloader) ]
  )
}
function renderAbsolutePreloader(h) {
  if (this.state === states.loading) {
    return h(
      'div',
      {
        class: 'preloader__holder preloader__holder--absolute'
      },
      [ h(preloader) ]
    )
  }
}
function renderRecipient(h, item) {
  if (item?.status) {
    return h(
      sticker,
      {
        props: {
          value: item.recipient,
          label: item.status,
          icon: requestStatuses[item.status].icon || icons.help_outline,
          color: requestStatuses[item.status].color || Colors.grey,
          copy: true
        }
      }
    )
  }
}
function renderDate(h, item) {
  return h(
    date,
    {
      props: {
        value: item
      }
    }
  )
}
function renderItem(h, item) {
  return h(
    'div',
    {
      class: `${services['otp-handler']}-item ${services['otp-handler']}-item--request service-template-item`,
      on: {
        click: () => {
          this.item = item
          this.showDialog = true
        }
      }
    },
    [
      renderRecipient.call(this, h, item),
      renderDate.call(this, h, item)
    ]
  )
}
function renderItems(h) {
  return h(
    'div',
    {
      class: `${services['otp-handler']}-items`
    },
    [
      this.items.map(item => {
        return renderItem.call(this, h, item)
      }),

      renderAbsolutePreloader.call(this, h)
    ]
  )
}
function renderBody(h) {
  if (this.hasItems) {
    return renderItems.call(this, h)
  } else {
    switch (this.state) {
      case states.loading: return renderPreloader.call(this, h)
      case states.ready:
      case states.success:
      default: return h(components.empty)
    }
  }
}

function renderPagination(h) {
  return h(
    pagination,
    {
      props: {
        value: this.pagination,
        service: services['otp-handler'],
        edgeArrows: false
      },
      on: {
        input: event => {
          this.pagination = event
        }
      }
    }
  )
}
function renderRefreshButton(h) {
  return h(
    buttonRefresh,
    {
      props: {
        state: this.loading,
        shortClickMethod: () => {
          return this.getItems()
        }
      }
    }
  )
}
function renderFooter(h) {
  if (this.items.length) {
    return h(
      'div',
      {
        class: 'fjcfe grid-gap--8 pa-2'
      },
      [
        renderPagination.call(this, h),
        renderRefreshButton.call(this, h)
      ]
    )
  }
}

function renderDivider(h) {
  if (this.hasItems) {
    return h(components.divider)
  }
}
function renderTab(h, key) {
  return h(
    components.card,
    {
      props: {
        rounded: true,
        outline: true
      },
      key
    },
    [
      renderBody.call(this, h),
      renderDivider.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}

function renderContent(h) {
  return h(
    components.tabs,
    {
      props: { value: this.tab },
      scopedSlots: {
        body: () => {
          return this.tabs.map(tab => {
            return renderTab.call(this, h, tab.key)
          })
        }
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8'
    },
    [
      renderHeader.call(this, h),
      renderContent.call(this, h),
      renderDialog.call(this, h)
    ]
  )
}
